// The picture to show for a part, as the parts grid has always done it: the part's own image when it has
// one, otherwise a placeholder so a row without a picture still lines up with the rows that have one.
// A tileImageUrl is only usable if it is a full URL - older parts hold a bare file name that resolves
// to nothing.
const NO_PART_IMAGE = "https://placehold.co/400x400?text=No+Part+Image";

export function PartImageUrl(imageUrl?: string | null): string {
	if (imageUrl == null || imageUrl.includes("http") === false) {
		return NO_PART_IMAGE;
	}

	return imageUrl;
}
